import { StyleCard, StyleLeftCardWrapper, StyleRightCardWrapper } from './style'
import Typography from '@components/typography'
import Button from '@components/button'
import Image from '@components/image'
import Banner from './banner.png'
import Svg from '@components/svg'

const WithdrawBanner = () => {
  return (
    <StyleCard>
      <StyleLeftCardWrapper>
        <Typography content={'Request Withdrawal'} size={18} tc="primary" />
        <Typography
          content={`"Ready when you are — request your money securely."`}
          size={14}
          tc="text"
        />
        <Button
          title={`Withdraw Now`}
          radius={8}
          styleButton="padding:0px 15px;font-size:12px;font-weight:300;"
          height={40}
          styleButtonWrapper="margin-top:10px;"
          leftComponent={<Svg svg="requestWithdraw" />}
        />
      </StyleLeftCardWrapper>
      <StyleRightCardWrapper>
        <Image src={Banner} height={200} />
      </StyleRightCardWrapper>
    </StyleCard>
  )
}

export default WithdrawBanner
